export default {
  INIT: 'MERCHANT_INIT',
  FETCH_MERCHANT: 'MERCHANT/FETCH_MERCHANT',
}
